import CashbackBalance from './CashbackBalance';
import ClaimOrderCashback from './ClaimOrderCashback';
import EarnCashbackTag from './EarnCashbackTag';
import OrderBasketCashback from './OrderBasketCashback';

export default {
  CashbackBalance,
  ClaimOrderCashback,
  EarnCashbackTag,
  OrderBasketCashback,
};
